import {
  StanleyQueryHistoryItemResponse,
  StanleyQueryResponse,
  StanleyQuerySuggestion,
} from './types';

/** Cached GET `/item` payload matches POST suggestions shape for the results UI. */
export const mapHistoryItemToStanleyResponse = (
  item: StanleyQueryHistoryItemResponse
): StanleyQueryResponse => ({
  summary: item.summary,
  queries: (item.queries ?? []) as StanleyQuerySuggestion[],
  strategic_warning: item.strategic_warning,
  strategic_warning_level: item.strategic_warning_level,
});
